<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <strong class="card-title mb-3">{{ 'Stock Return' }}</strong>
                </div>
                <div class="col-md-5">

                </div>
                <div class="col-md-1">
                    <goback></goback>
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="row mb5 tab-content">
                <!-- <div class="row mt-15"> -->
                <div class="col-md-6">
                    <div class="d-flex align-items-center m-1">
                        Date: <datepicker :input-class="'form-control'" style="padding-left: 0.5rem;"
                            :format="'dd-MM-yyyy'" v-model="ddate" @selected="changeDateFilter($event)">
                        </datepicker>
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-end">
                    <download class="pull-left" :tableId="'stock-return'" :fileName="'stock-return'"></download>
                </div>
                <!-- </div> -->
                <table style="table-layout: fixed; width: 100%;">
                    <div class="table-responsive scrollbar app m-3" v-dragscroll="true">
                        <table id="stock-return" class="table table-bordered fonts11 app-inner"
                            style="font-size: 11px;">
                            <thead v-if="tableFields.length > 0">
                                <tr>
                                    <th class="align-middle" v-for="(lblObj, lIdx) in tableFields">{{
                                        getLabel(lblObj.title) }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="tableFields.length > 0">
                                <tr v-for="(row, index, key) in rawData" v-bind:key="'row' + row + index">
                                    <!-- <td>{{ (parseInt(page) === 1) ? (index + 1) : (((parseInt(page) - 1) * perPage) + (index + 1)) }}</td> -->
                                    <td v-for="(fieldObj, ind) in tableFields" v-bind:key="ind + '-td-' + index + key">
                                        <!-- { title: "actual sales growth cagr 5 years", field: "s1_data", sub_field: "actual_sales_growth_cagr_5_years" }, -->
                                        <span>
                                            <a v-if="fieldObj.sub_field == ''" class="a-btn">{{ row[fieldObj.field]
                                            }}</a>
                                            <a v-else class="a-btn">{{ row[fieldObj.field][fieldObj.sub_field] }}</a>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="rawData.length === 0">
                                <tr>
                                    <td :colspan="tableFields.length">
                                        <div class="alert alert-danger" role="alert">No data found!</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </table>
                <!-- <div class="row mt-15">
                <div class="col-md-6">
                    <download class="pull-left" :tableId="'stock-return'" :fileName="'stock-return'"></download>
                </div>
                <div class="col-md-1">
                    <download :tableId="'stock-return'" :fileName="'stock-return'"></download>
                </div>
                <div class="col-md-5">
                    <div class="pull-right">
                        <ul v-if="totalPages != 1" class="pagination">
                            <li :class="{ disabled: prevDisabled }" class="page-item">
                                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{ '&lt;&lt;' }}</a>
                            </li>
                            <li :class="{ disabled: prevDisabled }" class="page-item">
                                <a class="page-link" @click.prevent="prev()" href="#">{{ '&lt;' }}</a>
                            </li>
                            <li v-for="page in pages" v-bind:key="page" class="page-item"
                                :class="(current_page == page) ? 'active' : ''">
                                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                            </li>
                            <li :class="{ disabled: nextDisabled }" class="page-item">
                                <a class="page-link" href="#" @click.prevent="next()">{{ '&gt;' }}</a>
                            </li>
                            <li :class="{ disabled: nextDisabled }" class="page-item">
                                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{ '&gt;&gt;' }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
                <!--  </div>
            </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
    components: { Datepicker },
    mixins: [commonMixins, pCommonMixins],
    props: [],
    mounted() {
        //this.getS1SectorData();
    },
    created() {
        this.getStockReturnData();
    },
    data() {
        return {
            ddate: new Date().setDate(new Date().getDate() - 1),
            tableFields: [
                { title: "Code", field: "co_code", sub_field: "" },
                { title: "Company Name", field: "companyname", sub_field: "" },
                { title: "Sector Name", field: "sectorname", sub_field: "" },
                { title: "1-Month Previous Price Return", field: "one_month_previous_price_return", sub_field: "" },
                { title: "3-Month Previous Price Return", field: "three_month_previous_price_return", sub_field: "" },
                { title: "6 Month Previous Price Return", field: "six_month_previous_price_return", sub_field: "" },
                { title: "Last Year Price Return", field: "last_year_price_return", sub_field: "" },
                { title: "3-Year Previous Price Return", field: "three_year_previous_price_return", sub_field: "" },
                { title: "5-Year Previous Price Return", field: "five_year_previous_price_return", sub_field: "" },
                { title: "10-Year Previous Price Return", field: "ten_year_previous_price_return", sub_field: "" },
            ],
            rawDataApi: "frontend/stock_return/get",
            rawData: [],
            searchText: "",
            curYear: new Date().getFullYear(),
            minRange: [],
            maxRange: [],
            selFilter: [],
            selRangeFilter: 0,
            sectorData: [],
            page: 1,
            perPage: 700,
            current_page: 1,
            pageToLoad: 1,
            totalPages: 1,
            prevDisabled: 1,
            nextDisabled: 0,
            pages: [],
            isDownload: 0,
            appTitle: "",
            dateFilterTabWiseData: [],
        };
    },
    methods: {
        changeDateFilter(e) {
            console.log("Date Selected", e);
            this.ddate = new Date(e).toLocaleDateString('en-US').replace(/\//g, '-');
            this.getStockReturnData();
        },
        getStockReturnData() {
            let self = this;
            let param = { "insert_date": new Date(self.ddate).toLocaleDateString('en-GB').replace(/\//g, '-') };
            console.log("Call Stock Return API");

            http.post(self.rawDataApi, param, (error, response) => {
                console.log('getStockReturnData :: response:: ', response);
                if (response.status === "success") {
                    self.rawData = response.data;
                }
            });
        },
        prev() {
            this.pageToLoad = this.current_page - 1;
            this.fillTable();
        },
        goToPage(page) {
            this.pageToLoad = page;
            this.fillTable();
        },
        next() {
            console.log(this.$route.query);
            this.pageToLoad = this.current_page + 1;
            this.prevDisabled = 0;
            this.fillTable();
        },
        fillTable() {
            this.page = this.pageToLoad;
            if (this.pageToLoad == this.totalPages) {
                this.nextDisabled = 1;
            } else {
                this.nextDisabled = 0;
            }
            if (this.pageToLoad == 1) {
                this.prevDisabled = 1;
            } else {
                this.prevDisabled = 0;
            }
            this.current_page = this.pageToLoad;
            //this.getS1Data();
        },
        downloadAll() {
            this.isDownload = 1;
            //this.getS1Data();
        }
    },
    /* watch: {
    },
    computed: {
        
    } */
};
</script>
<style scoped>
form .col-md-3 {
    width: 40%;
}

.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    /* table-layout: fixed; */
}

.table-responsive {
    width: auto;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>



// WEBPACK FOOTER //
// src/views/company/StockReturn.vue